import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Button from '../../../../components/actions/Button'
import PageWrapper from '../../../../wrappers/pageWrapper/PageWrapper'

const AccountDeletion: React.FC = () => {
	const { t } = useTranslation('pages_settings', {
		keyPrefix: 'accountManagement.dataRemoval',
	})

	const history = useHistory()

	return (
		<PageWrapper page='deleteAccount' appBarOptions={{ backPath: '/settings' }}>
			<Button
				className='![--background:theme(colors.highlight)] dark:![--background:theme(colors.highlight)]'
				onClick={() => history.push('/settings/account-management/delete-account-confirmation')}
			>
				{t('deleteAccount')}
			</Button>
			<div className='text-text-dark dark:text-white text-center mt-4'>
				{t('warning')} <br />{' '}
				<span className='text-highlight tracking-wide font-semibold'>{t('permanently')}</span>
			</div>
		</PageWrapper>
	)
}
export default AccountDeletion
